import { Icon } from './icon';
import { MailOutlined, UserOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { ROUTER } from '../../../constants/router';
import useQuery from '../../../util/useQuery';
import { Form } from 'antd';

export default function CardEmail({ email, form, isEditable }) {
    let navigate = useNavigate();
    const subjectEmail = Form.useWatch('subjectEmail', form);

    const params = useQuery();
    const active = params.get('id') === email?.customizeEmailId;

    const tagCategory = (category) => {
        switch (category) {
            case 'DS360':
                return 'Data Subject 360';
            case 'Consent':
                return 'Consent Management';
            default:
                return 'All Menu';
        }
    };

    const isConsent = email?.category === 'Consent';

    return (
        <button
            onClick={() => {
                if (isEditable) return;
                navigate(
                    ROUTER.CONFIGURATION.EMAIL_SETTING +
                        `?id=${email?.customizeEmailId}`
                );
                form.setFieldsValue({
                    subjectEmail: email?.subjectEmail,
                });
            }}
            style={{
                borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
            }}
            className={classNames(
                'text-left hover:bg-[#F8F4FF] duration-300 w-full pl-5 p-4 relative flex flex-col gap-2',
                {
                    'bg-[#F8F4FF]': active,
                    'cursor-default': isEditable,
                }
            )}
        >
            {active && (
                <div className="w-[6px] h-full bg-purple-PHX absolute left-0 top-0 rounded-tr-lg rounded-br-lg" />
            )}
            {!active && isEditable && (
                <div
                    className={classNames(
                        'absolute top-0 left-0 w-full h-full bg-[#ffffff]/80 z-20 transition duration-500',
                        'data-[close]:opacity-0 pointer-events-none',
                        'data-[leave]:duration-500 data-[leave]:ease-in-out data-[leave]:opacity-0'
                    )}
                />
            )}
            <div className="font-semibold text-purple-PHX">
                ประเภทอีเมล : {email?.templateTypeName}
            </div>
            <div className="font-semibold flex items-start gap-2">
                <div className="flex items-center gap-2 flex-shrink-0">
                    <MailOutlined className="text-purple-PHX" /> Subject Email :
                </div>{' '}
                {active ? subjectEmail : email?.subjectEmail}
            </div>
            <div className="font-semibold flex items-center gap-2">
                <UserOutlined className="text-purple-PHX" /> ส่งถึง :{' '}
                {email?.receiver}
            </div>
            <div>{email?.description}</div>
            <div
                className={classNames(
                    'flex items-center gap-2 px-2 w-max text-[12px] font-medium rounded-md py-0.5',
                    {
                        'bg-[#EEE5FF] text-purple-PHX': !isConsent,
                        'bg-[#FFF7E6] text-[#FF6E04]': isConsent,
                    }
                )}
            >
                {Icon.tag}
                <span>{tagCategory(email.category)}</span>
            </div>
        </button>
    );
}
